import Vue from 'vue';
import slider from '~lib/src/components/slider.vue';

Vue.component('sf-slider', slider);
